import React from "react";
import PageHeading from "../shared/PageHeading";
import Spacer from "../shared/Spacer";
import UnderstandingEnergyImbalances from "../sections/body-coding/UnderstandingEnergyImbalances";
import HowBodyCodingWorks from "../sections/body-coding/HowBodyCodingWorks";
import BodyCodingBenefits from "../sections/body-coding/BodyCodingBenefits";
import BodyEnergySystems from "../sections/body-coding/BodyEnergySystems";
import DistanceBodyCoding from "../sections/body-coding/DistanceBodyCoding";
import Footer from "../shared/Footer";

const WhatIsBodyCoding = () => {
	return (
		<div>
			<PageHeading heading="Body Coding" />
			{/* Spacer to push content down so it can scroll over the fixed page heading */}
			<div style={{ height: '30vh' }}></div>
						<div className="content-wrapper" style={{ 
				position: 'relative', 
				zIndex: 10, 
				backgroundColor: 'white',
				minHeight: '100vh'
			}}>
				<div className="d-none d-md-block">
					<Spacer />
				</div>
				<UnderstandingEnergyImbalances />
				<Spacer />
				<HowBodyCodingWorks />
				<div className="bg-brand-gradient">
					<Spacer />
					<BodyCodingBenefits />
					<Spacer />
				</div>
				<Spacer />
				<BodyEnergySystems />
				<Spacer />
				<Spacer />
				<DistanceBodyCoding />
				<Spacer />
				<Footer />
			</div>
		</div>
	);
};

export default WhatIsBodyCoding;